import { render, staticRenderFns } from "./PlayerPendingInfoFollowingLink.vue?vue&type=template&id=ac4ece36&scoped=true&"
import script from "./PlayerPendingInfoFollowingLink.vue?vue&type=script&lang=js&"
export * from "./PlayerPendingInfoFollowingLink.vue?vue&type=script&lang=js&"
import style0 from "./PlayerPendingInfoFollowingLink.vue?vue&type=style&index=0&id=ac4ece36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4ece36",
  null
  
)

export default component.exports